module.exports = __webpack_public_path__ + "img/candidate3.372849f0.png";